/**
 * Converts a given date to Thai date format.
 * @param {Date} dateIn - The date to convert.
 * @param {boolean} [time=true] - Whether to include the time in the Thai date format.
 * @returns {string} The Thai date in the format "day month year" (e.g. "1 มกราคม 2565").
 * If time is included, the format will be "day month year hours:minutes:seconds" (e.g. "1 มกราคม 2565 12:30:45").
 */
export const toThaiDate = (dateIn, time = true, m7 = true) => {
    let date = new Date(dateIn);
    const thaiYear = date.getFullYear() + 543;
    const thaiMonths = {
        1: "มกราคม", 2: "กุมภาพันธ์", 3: "มีนาคม", 4: "เมษายน", 5: "พฤษภาคม", 6: "มิถุนายน", 7: "กรกฎาคม", 8: "สิงหาคม", 9: "กันยายน", 10: "ตุลาคม", 11: "พฤศจิกายน", 12: "ธันวาคม",
    };
    const thaiMonthName = thaiMonths[date.getMonth() + 1];
    const day = date.getDate();
    const hours = date.getHours().toString().padStart(2, '0') - (m7 ? 7 : 0);
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const thaiDateTime = `${day} ${thaiMonthName} ${thaiYear} ${time && `${hours}:${minutes}:${seconds}`}`;
    return thaiDateTime;
}